// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonSettingsLocked_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 7C13.6569 7 15 8.34315 15 10V11H16V16H8V11H9V10C9 8.34315 10.3431 7 12 7ZM13 10V11H11V10C11 9.44772 11.4477 9 12 9C12.5523 9 13 9.44772 13 10Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0H13L13.7155 2.14659C15.1991 2.40308 16.5707 2.98647 17.7535 3.8199L19.7781 2.80757L21.1923 4.22179L20.18 6.24641C21.0135 7.42919 21.5969 8.80082 21.8534 10.2844L24 11V13L21.8534 13.7155C21.5969 15.1991 21.0135 16.5708 20.18 17.7535L21.1923 19.7781L19.7781 21.1923L17.7535 20.18C16.5708 21.0135 15.1991 21.5969 13.7155 21.8534L13 23.9999H11L10.2845 21.8534C8.80083 21.5969 7.42917 21.0135 6.24637 20.18L4.22179 21.1923L2.80758 19.7781L3.81988 17.7535C2.98644 16.5707 2.40304 15.1991 2.14656 13.7155L0 13V11L2.14657 10.2844C2.40307 8.80084 2.98648 7.42922 3.81992 6.24645L2.80759 4.22178L4.2218 2.80757L6.24648 3.81991C7.42924 2.98647 8.80086 2.40308 10.2845 2.14659L11 0ZM12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13399 5 4.99998 8.13401 4.99998 12C4.99998 15.866 8.13399 19 12 19Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonSettingsLocked is a generated icon component.
 */
let IconCommonSettingsLocked = IconCommonSettingsLocked_1 = class IconCommonSettingsLocked extends IconBaseElement {
    render() {
        return html `${IconCommonSettingsLocked_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonSettingsLocked.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonSettingsLocked = IconCommonSettingsLocked_1 = __decorate([
    customElement('zui-icon-common-settings-locked')
], IconCommonSettingsLocked);
export { IconCommonSettingsLocked };
